module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescirp12-1d1333cf41b876b59547341ea73336ea.jpg";